/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_2_TitleInputs */

const en_mk_agent_2_title = /** @type {(inputs: Mk_Agent_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposes, you approve`)
};

const id_mk_agent_2_title = /** @type {(inputs: Mk_Agent_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengusulkan, kamu yang menyetujui`)
};

/**
* | output |
* | --- |
* | "Proposes, you approve" |
*
* @param {Mk_Agent_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_2_title = /** @type {((inputs?: Mk_Agent_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_2_title(inputs)
	return en_mk_agent_2_title(inputs)
});